import flatpickr from "../../../builder/node_modules/flatpickr";
import Choices from "../../../builder/node_modules/choices.js";

export default () => {
  Alpine.data('bookingCalendar', (slug, flow, options, autoSubmit = false) => ({
    value: '',
    slug,
    flow,
    options,
    multiple: false,
    autoSubmit,
    selectValue: '',
    bookingLink: '',

    init() {
      this.composeLink(); // based on initial slug/flow (can be empty)

      const calendarContainer = this.$refs.calendarContainer;
      // Init flatpickr
      this.picker = flatpickr(this.$refs.picker, {
        altInput: true,
        altFormat: 'd M Y',
        dateFormat: 'Y-m-d',
        disableMobile: true,
        appendTo: calendarContainer || document.body,
        minDate: new Date(),
        onChange: (selectedDates, dateString, instance) => {
          // if (selectedDates.length > 0 && selectedDates[0].getDate() !== new Date().getDate()) {
            this.value = dateString;
          // }
        },
      });

      this.$watch('value', () => {
        this.picker.setDate(this.value);
        this.composeLink();
      });

      // Initialize Choices dropdown
      if (this.options?.length && this.$refs.select) {
        // Clear any existing options
        this.$refs.select.innerHTML = '';


        const formattedChoices = this.options
          .map(({ slug, name, emoji }) => ({
            value: slug || '',
            label: emoji ? `${name} <span class="emoji">${emoji}</span>` : name,
            customProperties: {
              searchLabel: name
            },
          }));

        this.choices = new Choices(this.$refs.select, {
          searchEnabled: true,
          searchFields: ['customProperties.searchLabel'], // correct path
          fuseOptions: {
            keys: ['customProperties.searchLabel'],
            threshold: 0.3,
          },
          itemSelectText: '',
          shouldSort: false,
          allowHTML: true,
          choices: [
            {
              value: '',
              label: 'Select a city',
              selected: true,
              disabled: true,
            },
            ...formattedChoices,
          ],
        });


        // Watch selection change
        this.$refs.select.addEventListener('change', () => {
          const selectedSlug = this.choices.getValue(true); // value = slug
          const selectedItem = this.options.find(opt => opt.slug === selectedSlug);

          this.selectValue = selectedSlug;

          if (selectedItem && selectedItem.slug && selectedItem.flow_id) {
            this.slug = selectedItem.slug;
            this.flow = selectedItem.flow_id;
          } else {
            // Use initial slug/flow if available
            this.slug = slug;
            this.flow = flow;
          }

          this.composeLink();
        });
      }
    },

    composeLink() {
      if (!this.slug) return;

      const base = `https://fareharbor.com/embeds/book/${this.slug}`;
      const flowQuery = this.flow ? `?full-items=yes&flow=${this.flow}` : '';

      if (!this.value) {
        this.bookingLink = this.flow ? `${base}/items/calendar/${flowQuery}` : slug;
      } else {
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = String(now.getMonth() + 1).padStart(2, '0');

        this.bookingLink = this.flow ? `${base}/items/date/${this.value}/${currentYear}/${currentMonth}/${flowQuery}` : slug;
      }

      if (this.autoSubmit && this.value) {
        window.location.href = this.bookingLink;
      }
    },
  }));

  Alpine.data('cityDropdown', (options) => ({
    value: '',
    options,
    multiple: false,
    selectValue: '',

    init() {
      // Initialize Choices dropdown
      if (this.options?.length && this.$refs.select) {
        // Clear any existing options
        this.$refs.select.innerHTML = '';


        const formattedChoices = this.options
          .map(({ city_slug, name, emoji }) => ({
            value: city_slug || '',
            label: emoji ? `${name} <span class="emoji">${emoji}</span>` : name,
            customProperties: {
              searchLabel: name
            },
          }));

        this.choices = new Choices(this.$refs.select, {
          searchEnabled: true,
          searchFields: ['customProperties.searchLabel'], // correct path
          fuseOptions: {
            keys: ['customProperties.searchLabel'],
            threshold: 0.3,
          },
          itemSelectText: '',
          shouldSort: false,
          allowHTML: true,
          choices: [
            {
              value: '',
              label: 'Select a city',
              selected: true,
              disabled: true,
            },
            ...formattedChoices,
          ],
        });


        // Watch selection change
        this.$refs.select.addEventListener('change', () => {
          const selectedSlug = this.choices.getValue(true); // value = slug

          window.location = `${window.location.origin}/${selectedSlug}/`;
        });
      }
    },
  }));
};
